import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import AssignmentProposalModal from 'Components/General/AssignmentProposalModal/AssignmentProposalModal'
import { getAssignmentProposalInitialData } from 'Components/reusable/DataContext/InitialData'
import { assignmentProposalSchema } from 'Components/reusable/DataContext/ValidationSchema'
import colors from 'constants/colors'
import { useUser } from 'hooks'

/**
 * React functional component for displaying a "Not Found" card and related actions.
 * The card only offers a shortlist request, so it is hidden where requests can't be sent
 * (no `searchProposals` feature, i.e. no lead email configured).
 */
const NotFound: React.FC = () => {
  const { t } = useTranslation()
  const { features } = useUser()

  const [openProposal, setOpenProposal] = useState<boolean>()

  if (!features.includes('searchProposals')) return null

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Grid
            container
            justifyContent="center"
            sx={{
              border: `1px solid ${colors.borderColor}`,
              borderRadius: '5px',
              padding: '1em',
              marginTop: '1em',
              marginBottom: '1em',
            }}
          >
            <Grid sx={{ textAlign: 'center', marginY: '1em' }} size={12}>
              <Typography sx={{ fontWeight: 'bold' }}>{t('search.notFound')}</Typography>
            </Grid>
            <Grid sx={{ textAlign: 'center', marginBottom: '1em' }} size={12}>
              <Typography>{t('search.notFoundDescription')}</Typography>
            </Grid>
            <Grid sx={{ textAlign: 'center', marginBottom: '1em' }} size={12}>
              <Button
                data-testid="button-search-not-found-send-request"
                variant="contained"
                onClick={() => {
                  setOpenProposal(true)
                }}
              >
                {t('search.sendRequest')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {openProposal && (
        <AssignmentProposalModal
          onClose={() => {
            setOpenProposal(false)
          }}
          initialData={getAssignmentProposalInitialData()}
          schema={assignmentProposalSchema()}
          localeBase="search.request"
          submitOnModal={true}
          hideLanguageHelperText={true}
          maxWidth="md"
          fullWidth={true}
          customButtons={true}
          noEscClose
        />
      )}
    </>
  )
}

export default NotFound
